<template>
  <div class="login">
    <div style="​position: relative" class="left">
      <div
        style="
          position: absolute;
          top: 40px;
          left: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          font-size: 28px;
        "
      >
        <img style="width: 262px" src="@/assets/logo@3x.png" alt="" srcset="" />
        <div
          style="
            width: 10px;
            height: 10px;
            margin: 0 13px;
            background: #fff;
            border: 100%;
            border-radius: 100%;
          "
        ></div>
        经办人管理系统
      </div>
      <img class="leftBanner" src="../assets/login.png" alt />
    </div>
    <div class="right">
      <div class="loginCard">
        <div class="loginTitle">
          <img src="../assets/login/welcome.png" alt />
        </div>
        <div class="tab">
          <div @click="tab(1)">
            手机登录
            <span v-if="active == 1" class="block"></span>
          </div>
          <div @click="tab(2)">
            账号登录
            <span v-if="active == 2" class="block"></span>
          </div>
        </div>
        <div class="form" v-if="active == 2">
          <el-form
            class="cionlogin"
            :model="loginFrom"
            :rules="loginRules"
            ref="ruleForm"
          >
            <el-form-item prop="username">
              <el-input
                prefix-icon="el-icon-user-solid"
                placeholder="请输入账号"
                v-model="loginFrom.username"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                :type="passw"
                prefix-icon="el-icon-lock"
                v-model="loginFrom.password"
                placeholder="请输入密码" clearable show-password

              >
                <!-- <i slot="suffix" :class="icon" @click="showPass"></i> -->
              </el-input>
              <!-- <el-input
                prefix-icon="el-icon-lock"
                placeholder="请输入密码"
                type="password"
                v-model="loginFrom.password"
              ></el-input> -->
            </el-form-item>
          </el-form>
          <div style="display: flex; justify-content: space-between;">
            <el-link type="primary" @click="$router.push('/register')"
              >注册账号</el-link
            >
              <el-link type="primary" @click="$router.push('/register')"
              >找回密码</el-link
            >
            <!-- <el-checkbox label="记住密码" name="type"></el-checkbox> -->
            <!-- <div @click="$router.push('/register')">注册账号</div> -->
            <!-- <div @click="$p.url('/forget')">忘记密码</div> -->
          </div>
          <div class="loginBtn">
            <el-button type="primary" @click="login">登录</el-button>
          </div>
        </div>
        <div class="form" v-if="active == 1">
          <div class="caImg">
            <el-form
            class="cionlogin"
            :model="loginFrom"
            :rules="loginRules"
            ref="ruleForm"
          >
            <el-form-item prop="username">
              <el-input
                prefix-icon="el-icon-user-solid"
                placeholder="请输入手机号"
                v-model="loginFrom.username"
              ></el-input>
            </el-form-item>

              <el-form-item prop="yzm">
                        <div  class="code">
                            <el-input prefix-icon="el-icon-coordinate" placeholder="请输入验证码" v-model="loginFrom.yzm"></el-input>
                            <div style="display: flex;
    justify-content: center;
    margin-left: 10px;
}" class="codeImg" @click="getcodeimg">
                               <el-button :disabled="times!==90" style="     width: 90px;   padding: 9px;
    height: 40px;" @click="send" type="primary" plain>{{yanzheng}}</el-button>
                            </div>
                        </div>
            </el-form-item>
          </el-form>
          </div>
          <div class="loginBtn">
            <el-button type="primary" @click="logins">登录</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- PDF预览 -->
<el-dialog title="PDF预览" :visible.sync="dialogVisible4L" width="70%" append-to-body center>
     <iframe :src="pdfSrc" frameborder="0" style="width: 100%; height: 100%"></iframe>
</el-dialog>
  </div>
</template>

<script>
import { login } from "@/api/system/login";
 import axios from "axios"
export default {
  data() {
    return {
      active: 2,
      loginFrom: {
        // username: "wang",
        // password: "111111",
        username: "",
        password: "",
        yzm:"",
        id: "",
      },
          times:90,
         yanzheng:"获取验证码",
      pdfSrc:"https://api.hnzyxsbh.com//uploads/image/20221128/63841ee1f366a.pdf",
      dialogVisible4L:false,
      codeUrl: "",
      //用于显示或隐藏添加修改表单
      add: false,
      //用于改变Input类型
      passw: "password",
      //用于更换Input中的图标
      icon: "el-input__icon el-icon-view",
      loginRules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        // code: [
        //     { required: true, message: '请输入验证码', trigger: 'blur' },
        // ],
      },
      captchaOnOff: false,
    };
  },
  created(){
if(sessionStorage.getItem('token')){
   this.$router.push({
              path: "/",
            });
}
  },
  mounted() {
    this.getcodeimg();
  },
  methods: {
    getcodeimg() {
      // getcode().then(res=>{
      //     this.codeUrl = window.URL.createObjectURL(res)
      // })
    },
          send() {
          if(this.mobile==""){
            return this.$message({
          showClose: true,
          message: '请输入手机号',
          type: 'warning'
        });
          }
      // this.daojishi();
      // return;
      axios({
        url: "https://api.hnzyxsbh.com/apply/sms/send",
        method: "post", // params: '必须是一个无格式对象 query参数',
        data: {
          mobile: this.loginFrom.username,
          event: "register",
        },
        timeout: 10000,
        headers: {
          token: sessionStorage.getItem("token"),
        },
      })
        .then((res) => {
          console.log(res.data.msg);
          if (res.data.code == 1) {
            this.cionbutton = true;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.daojishi();
            // this.$router.push("/BidSecurity/ElectronicProtocol");
          } else {
            this.$message.error(res.data.msg);
          }
          // this.$router.push("/BidSecurity/Bidpayment");
        })
        .catch((err) => {
          console.log("失败", err);
          // this.$notify.error({
          //   message: err.response.data.msg,
          // });
        });
    },
    showPass() {
      //点击图标是密码隐藏或显示
      if (this.passw == "text") {
        this.passw = "password";
        //更换图标
        this.icon = "el-input__icon el-icon-view";
      } else {
        this.passw = "text";
        this.icon = "el-input__icon el-icon-loading";
      }
    },
    logins() {
      this.dialogVisible4L=true;
      this.$alert("检测不到豫资签", "警告", {
        confirmButtonText: "确定",
        callback: (action) => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        },
      });
    },
    login() {
      login(this.loginFrom).then((res) => {
        sessionStorage.setItem("token", res.data.data.token);
        sessionStorage.setItem("cardname", res.data.data.cardname);
        sessionStorage.setItem("username", res.data.data.username);
        // console.log( res.data.data.id,'user');
        if (res.data.code == 1) {
          if (res.data.data.grrz == 1) {
            this.$router.push({
              path: "/",
            });
          } else {
            this.$message({
              showClose: true,
              message: "个人未认证",
              type: "warning",
            });
            this.$router.push({
              path: "/PersonalRealnames",
            });
            return;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    tab(i) {
      this.active = i;
    },
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          resolve(e.target.result);
        };
        // readAsDataURL
        fileReader.readAsDataURL(blob);
        fileReader.onerror = () => {
          reject(new Error("blobToBase64 error"));
        };
      });
    },
  },
};
</script>
<style >
.cionlogin .el-input--prefix .el-input__inner {
  padding-left: 40px !important;
}
.el-icon-user-solid:before {
  content: "\E7A5";
  font-size: 22px;
}
.el-icon-lock:before {
  content: "\E6E5";
  font-size: 22px;
}
</style>
<style scoped  lang="scss">
.login {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  background: #5a7aec;
  .left {
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .leftBanner {
      width: 690px;
      height: 690px;
    }
  }
  .right {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;

    .loginCard {
      // padding: 30px;
      width: 400px;
      height: 400px;
      box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      border: 1px solid #f5f5f5;
      .tab {
        display: flex;
        align-items: center;
        // justify-content: space-evenly;
        padding-left: 30px;
        div {
          font-size: 18px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          width: 30%;
          height: 60px;
          line-height: 75px;
          text-align: center;
          position: relative;
          cursor: pointer;
          span {
            display: inline-block;
            width: 100%;
            height: 3px;
            background: #1890ff;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
      }
      .title {
        margin-top: 10px;
        margin-left: 150px;
      }
      .form {
        width: 400px;
        padding: 30px;
        .caImg {
          // width: 200px;
          height: 113px;
          margin: 0 auto;
          margin-top: 5px;
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .loginTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
      }
      .isPassword {
        font-size: 12px;
        display: flex;
        padding-left: 10px;
        margin-bottom: 20px;
        align-items: center;
        justify-content: space-between;
        & > div {
          cursor: pointer;
        }
        & > div:nth-child(1) {
          color: #1890ff;
        }
      }
      .el-form-item__error {
        padding-left: 10px;
      }
      .code {
        display: flex;
        align-items: center;
        .codeImg {
          height: 40px;
        }
      }
      .loginBtn {
        padding-top: 23px;
        width: 100%;
        display: flex;
        justify-content: center;
        // margin-left: 35px;
        button {
          width: 300px;
          background: #1890ff;
          color: #fff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/xiugai.vue